import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center m-2" }
const _hoisted_2 = { class: "my-4 text-gray-700" }
const _hoisted_3 = { class: "text-xs" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "error-message" }
const _hoisted_6 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChargeSerialCharge = _resolveComponent("ChargeSerialCharge")!
  const _component_ReceiptChargeLink = _resolveComponent("ReceiptChargeLink")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseCard, { class: "sm:w-6/12 text-center" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.chargeablePeriodText), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.chargeable_period_option.chargeable_begin_at) + " ~ " + _toDisplayString(_ctx.chargeable_period_option.chargeable_end_at), 1)
        ]),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.chargeConfig['charge_type'] === 'charge_serial')
          ? (_openBlock(), _createBlock(_component_ChargeSerialCharge, {
              key: 1,
              chargeConfig: _ctx.chargeConfig,
              chargeable: _ctx.chargeable
            }, null, 8, ["chargeConfig", "chargeable"]))
          : (_ctx.chargeConfig['charge_type'] === 'point_specify')
            ? (_openBlock(), _createBlock(_component_ReceiptChargeLink, {
                key: 2,
                chargeConfig: _ctx.chargeConfig,
                chargeable: _ctx.chargeable
              }, null, 8, ["chargeConfig", "chargeable"]))
            : _createCommentVNode("", true),
        (_ctx.consentDescriptionVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", {
                class: "text-gray-700 text-xs",
                innerHTML: _ctx.chargeButtonDescription
              }, null, 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}